<template>
  <EuiContainer>
    <EuiGridRow class="mx-0 mt-2">
        <resultInvalidMails />
    </EuiGridRow>
  </EuiContainer>
</template>

<script>
import resultInvalidMails from '@/components/mails/resultInvalids.vue';
import { mapActions } from 'vuex';

export default {
  name: 'pages.mails.invalid',
  components: {
    resultInvalidMails,
  },
  mounted() {
    this.storeResetChangeRoute();
    this.getMails();
  },
  methods: {
    ...mapActions({
      storeSearchMailsInvalids: 'logs/getMailsInvalidsLogs',
      storeResetChangeRoute: 'application/resetChangeRoute',
      storeStartLoading: 'application/startLoading',
      storeStartSearch: 'application/startSearch',
      storeFinishLoading: 'application/finishLoading',
    }),
    getMails() {
      this.storeStartSearch();
      this.storeStartLoading();
      this.storeSearchMailsInvalids()
        .then(() => {
          this.storeFinishLoading();
        })
        .catch(() => this.storeFinishLoading());
    },
  },
};
</script>
